import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh } from '@ah/design/mobile';
import { Music as MusicIcon } from 'lucide-react';
import { LATEST_SONGS_QUERY } from '../shared/queries.ts';
import type { MusicSong } from '../shared/types.ts';
import { SongRow, SongListSkeleton, ErrorRetry, MUSIC_TABS } from './_parts.tsx';

export function MusicLatest() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['music', 'latest'],
    queryFn: async () => {
      const res = await gql.request<{ latestSongs: MusicSong[] }>(LATEST_SONGS_QUERY, { limit: 50 });
      return res.latestSongs;
    },
    refetchInterval: 60_000,
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Music" />
      <PillTabs tabs={MUSIC_TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <SongListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load music." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <MusicIcon size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No tracks yet — the AI band is warming up.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((s) => <SongRow key={s.id} song={s} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
